export default __webpack_public_path__ + "static/media/bgdemo.50edbbb5.jpg";